import axios from "axios";
import { useEffect, useState } from "react";
import { FaChevronLeft, FaChevronRight, FaListAlt, FaSearch } from "react-icons/fa";
import { MdPendingActions } from 'react-icons/md';
import { useNavigate } from "react-router-dom";

export default function PendingFund() {
   const navigate = useNavigate();
   const [history, setHistory] = useState([]);
   const [searchTerm, setSearchTerm] = useState("");
   const [currentPage, setCurrentPage] = useState(1);
   const itemsPerPage = 7;

   const CUST_ID = sessionStorage.getItem("customer_id");
   //console.log("CUST_ID from sessionStorage:", CUST_ID);
   useEffect(() => {
      axios
         .get(`/auth/customer/pending-fund/${CUST_ID}`)
         .then((res) => {
            //console.log("API response data:", res.data);
            setHistory(res.data);
         })
         .catch((err) => {
            console.error("Failed to fetch pending fund", err);
         });
   }, [CUST_ID]);
   const filteredHistory = history.filter((item) => {
      const term = searchTerm.toLowerCase();

      const formattedDate = new Date(item.pickup_date).toLocaleDateString("en-GB", {
         day: "2-digit",
         month: "long",
         year: "numeric",
      });

      return (
         item.street_address?.toLowerCase().includes(term) ||
         item.pickup_time?.toLowerCase().includes(term) ||
         formattedDate.toLowerCase().includes(term) ||
         item.pickup_status?.toLowerCase().includes(term) ||
         String(item.req_id)?.toLowerCase().includes(term) ||
         String(item.cust_id)?.toLowerCase().includes(term) ||
         String(item.customer_amount)?.toLowerCase().includes(term) ||
         item.cust_paymentMethod?.toLowerCase().includes(term) ||
         item.paymentStatus?.toLowerCase().includes(term)
      );
   });

   const indexOfLastItem = currentPage * itemsPerPage;
   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
   const currentItems = filteredHistory.slice(indexOfFirstItem, indexOfLastItem);
   const totalPages = Math.ceil(filteredHistory.length / itemsPerPage);
   return (
      <div className="p-4">
         <div className="bg-white shadow-md rounded-2xl p-5 w-full px-2 sm:px-4 md:px-6 py-8">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6 px-4">
               <div className="w-full flex justify-center sm:justify-start">
                  <h2 className="flex items-center gap-2 text-2xl font-bold text-green-800">
                     <MdPendingActions className="text-4xl" /> Pending Fund
                  </h2>
               </div>
               <div className="w-full sm:w-72 flex items-center relative">
                  <span className="absolute left-3 text-gray-400"> <FaSearch />
                  </span>
                  <input type="text"
                     placeholder="Search Here..."
                     value={searchTerm}
                     onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                     }}
                     className="w-full rounded-lg border border-gray-300 pl-10 pr-3 py-2 focus:outline-none focus:ring-2 focus:ring-lime-400"
                  />
               </div>
            </div>

            <div className="w-full overflow-x-auto">
               <div className="flex justify-between items-center mb-3 px-2">
                  <div className="w-full bg-green-50 border border-green-200 rounded-lg px-4 py-2 shadow-sm">
                     <p className="text-sm font-medium text-green-900 flex items-center gap-2">
                        <FaListAlt className="text-green-700 text-lg" /> {/* ✅ Icon */}
                        Number of pending fund:
                        <span className="text-lg font-bold text-green-700">{history.length}</span>
                     </p>
                  </div>
               </div>
               <table className="min-w-max w-full border border-gray-200">
                  <thead className="bg-lime-100 text-green-900 uppercase font-semibold">
                     <tr>
                        <th className="px-3 py-4">S.no</th>
                        <th className="px-3 py-4">Req ID</th>
                        <th className="px-3 py-4">Customer</th>
                        <th className="px-4 py-4">Date</th>
                        <th className="px-4 py-4">Time</th>
                        <th className="px-4 py-4">Number of bags</th>
                        <th className="px-3 py-4">Amount</th>
                        <th className="px-3 py-4">Payment Method</th>
                        <th className="px-4 py-4">Payment Status</th>
                        <th className="px-4 py-4">Pickup Status</th>
                     </tr>
                  </thead>

                  <tbody>
                     {currentItems.length === 0 ? (
                        <tr>
                           <td colSpan="7" className="text-center py-6 text-gray-500">
                              No records found.
                           </td>
                        </tr>
                     ) : (
                        currentItems.map((payment, index) => (
                           <tr key={index} className="bg-white border-b hover:bg-gray-50">
                              <td className="px-3 py-4 text-center">{indexOfFirstItem + index + 1}</td>
                              <td className="px-4 py-4 text-center">{payment.req_id}</td>
                              <td className="px-3 py-4 text-center text-red-500">
                                 # {payment.cust_id} - {payment.first_name} {payment.last_name}
                              </td>
                              <td className="px-4 py-4 text-center">
                                 {new Date(payment.pickup_date).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                 })}
                              </td>
                              <td className="px-4 py-4 text-center">{payment.pickup_time}</td>
                              <td className="px-4 py-4 text-center">{payment.estimated_bags}</td>
                              <td className="px-4 py-4 text-center">₹{payment.customer_amount ?? 0}</td>
                              <td className="px-4 py-4 text-center">{payment.cust_paymentMethod}</td>
                              <td className="px-4 py-4 text-center">
                                 <span
                                    className={`inline-block px-3 py-1 text-xs font-semibold rounded-full ${payment.dri_paymentStatus === 'completed'
                                       ? 'bg-green-100 text-green-700'
                                       : payment.paymentStatus === 'pending'
                                          ? 'bg-yellow-100 text-yellow-700'
                                          : payment.paymentStatus === 'failed'
                                             ? 'bg-red-100 text-red-700'
                                             : 'bg-gray-100 text-gray-700'
                                       }`}
                                 >
                                    {payment.paymentStatus || 'Unknown'}
                                 </span>
                              </td>

                              <td className="px-4 py-4 text-center">
                                 <span className="px-2 py-1 rounded-lg text-xs font-medium bg-green-100 text-green-700">
                                    {payment.pickup_status}
                                 </span>
                              </td>
                           </tr>
                        ))
                     )}
                  </tbody>
               </table>

               {filteredHistory.length > itemsPerPage && (
                  <div className="flex justify-center mt-8">
                     <div className="flex bg-white rounded">
                        <button
                           onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                           disabled={currentPage === 1}
                           className={`bg-lime-100 py-1.5 px-2.5 rounded mx-1 flex items-center gap-1 text-xs ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
                              }`}
                        >
                           <FaChevronLeft className="text-green-900" /> Previous
                        </button>

                        {[...Array(totalPages)].map((_, index) => (
                           <button
                              key={index + 1}
                              onClick={() => setCurrentPage(index + 1)}
                              className={`py-1.5 px-2.5 rounded mx-1 text-xs ${currentPage === index + 1
                                 ? "bg-green-300 text-white"
                                 : "bg-lime-100 text-green-800"
                                 }`}
                           >
                              {index + 1}
                           </button>
                        ))}

                        <button
                           onClick={() =>
                              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                           }
                           disabled={currentPage === totalPages}
                           className={`bg-lime-100 py-1.5 px-2.5 rounded mx-1 flex items-center gap-1 text-xs ${currentPage === totalPages
                              ? "opacity-50 cursor-not-allowed"
                              : ""
                              }`}
                        >
                           Next <FaChevronRight className="text-green-900" />
                        </button>
                     </div>
                  </div>
               )}
            </div>
         </div>
      </div>
   );
}
